import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const OUTLAW = {
  title: "Outlaw Coaching",
  favicon: `${process.env.PUBLIC_URL}/favicon.ico`,
  faviconType: "image/x-icon",
  faviconSizes: undefined,
  appleTouchIcon: `${process.env.PUBLIC_URL}/outlaw-192.png`,
};

const STRENGTH_PILOT = {
  title: "Strength Pilot",
  favicon: `${process.env.PUBLIC_URL}/icons/sp-favicon-32.png`,
  faviconType: "image/png",
  faviconSizes: "32x32",
  appleTouchIcon: `${process.env.PUBLIC_URL}/icons/sp-icon-192.png`,
};

function applyAttrs(el, attrs) {
  Object.entries(attrs).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") {
      el.removeAttribute(key);
    } else {
      el.setAttribute(key, value);
    }
  });
}

function replaceLinkElement(id, attrs) {
  const head = document.head || document.getElementsByTagName("head")[0];
  if (!head) return;

  const existing = document.getElementById(id);
  const next = document.createElement("link");
  next.id = id;
  applyAttrs(next, attrs);

  if (existing && existing.parentNode) {
    existing.parentNode.replaceChild(next, existing);
  } else {
    head.appendChild(next);
  }
}

export default function RouteBranding() {
  const location = useLocation();

  useEffect(() => {
    if (typeof document === "undefined") return;

    const pathname = location.pathname || "/";
    const hostname = window.location.hostname || "";
    const isStrengthPilotHost =
      hostname === "strengthpilot.web.app" ||
      hostname === "strengthpilot.firebaseapp.com" ||
      hostname === "strengthpilot.de";

    const isStrengthPilot =
      isStrengthPilotHost ||
      pathname === "/login" ||
      pathname === "/register" ||
      pathname === "/dashboard" ||
      pathname.startsWith("/dashboard/") ||
      pathname.startsWith("/athlete/") ||
      pathname === "/athletes" ||
      pathname === "/settings";

    const branding = isStrengthPilot ? STRENGTH_PILOT : OUTLAW;

    document.title = branding.title;

    const faviconAttrs = {
      href: branding.favicon,
      type: branding.faviconType,
      sizes: branding.faviconSizes,
      rel: "icon",
    };

    replaceLinkElement("app-favicon", faviconAttrs);
    replaceLinkElement("app-favicon-shortcut", {
      ...faviconAttrs,
      rel: "shortcut icon",
    });

    replaceLinkElement("app-apple-touch-icon", {
      href: branding.appleTouchIcon,
      rel: "apple-touch-icon",
    });
  }, [location.pathname]);

  return null;
}
